import React, {useCallback} from 'react';

import {TREE_NAMES, TreeSkeleton} from 'src/components/features-section';
import {Skeleton} from 'src/components/skeleton';

import CheckBoxTree from '@pb/kit-component-checkbox-tree';
import Group from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';
import type {TreeStructure} from '@pb/kit-component-tree-v2';


type Props = {
    loading: boolean,
    dataSetsIds?: Array<string>,
    dataSetsTree: TreeStructure | null,
    onChange: (dataSetsIds: Array<string>) => void,
    layoutLevel?: number,
};

export const DataSetsSection: React.FC<Props> = ({loading, dataSetsIds, onChange, dataSetsTree, layoutLevel}) => {
    const onChangeDataSets = useCallback((changeTreeType: ChangeTreeType) => {
        let checkedIdsList = changeTreeType.checkedIdsList;
        if (!changeTreeType.checkedId?.includes(':')) {
            checkedIdsList = changeTreeType.checkedIdsList.filter(e => e !== changeTreeType.checkedId);
        }
        onChange(checkedIdsList);
    }, [onChange]);

    return (
        <Skeleton view={<TreeSkeleton rows={10}/>} shown={loading}>
            <Group direction="v" gap="m">
                <Label>Standard Data Sets</Label>
                {dataSetsTree ? (
                    <CheckBoxTree
                        data={dataSetsTree}
                        onChange={onChangeDataSets}
                        name={TREE_NAMES.STANDARD_DATA_SETS}
                        checkedIdsList={dataSetsIds}
                        expandedIdsTree={{}}
                        layoutLevel={layoutLevel}
                    />
                ) : null}
            </Group>
        </Skeleton>
    );
};
